"use strict";
// ALL THE NEW PLATFORMS SHOULD BE ON LOWER CASE
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_PLATFORM = exports.Platform = void 0;
var Platform;
(function (Platform) {
    /**
     * RBI brand first party native (Android, iOS) application.
     */
    Platform["app"] = "app";
    /**
     * Bite Ninja - https://biteninja.com
     * @deprecated
     */
    Platform["biteninja"] = "biteninja";
    /**
     * Flybuy - https://flybuy.radiusnetworks.com
     */
    Platform["flybuy"] = "flybuy";
    /**
     * DoorDash - https://www.doordash.com
     */
    Platform["doordash"] = "doordash";
    /**
     * "Order with Google" (a.k.a. Google Food Ordering) - https://food.google.com
     * https://developers.google.com/actions/food-ordering
     * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/884604942/Google+Food+Ordering+GFO
     * @deprecated
     */
    Platform["googleFoodOrdering"] = "googleFoodOrdering";
    /**
     * Grubhub - https://www.grubhub.com
     */
    Platform["grubhub"] = "grubhub";
    /**
     * The "internal" platform is only appropriate for activity originating
     * _within_ the RBI Tech platform, or from RBI Tech testing tools (e.g., Postman).
     */
    Platform["internal"] = "internal";
    /**
     * RBI Tech's kiosk platform (_excluding_ third-party kiosks like Tillster).
     */
    Platform["kiosk"] = "kiosk";
    /**
     * Skip the Dishes - https://www.skipthedishes.com
     */
    Platform["skip"] = "skip";
    /**
     * UberEats - https://www.ubereats.com
     */
    Platform["uber"] = "uber";
    /**
     * ASAP (f.k.a. Waitr) - https://asap.com
     * @deprecated
     */
    Platform["waitr"] = "waitr";
    /**
     * RBI brand first party web application.
     */
    Platform["web"] = "web";
    /**
     * Google AI ordering
     */
    Platform["google"] = "google";
    /**
     * Microsoft AI Ordering
     */
    Platform["microsoft"] = "microsoft";
    /**
     * Originally came from Menu Service. It may not be needed.
     * This is the "default" platform.
     */
    Platform["whitelabel"] = "whitelabel";
    /**
     * Originally came from Menu Service.
     * Kept here for backwards compatibility.
     * @deprecated
     */
    Platform["gfo"] = "gfo";
    /**
     * Originally came from Menu Service.
     * Kept here for backwards compatibility.
     * @deprecated
     */
    Platform["catering"] = "catering";
})(Platform || (exports.Platform = Platform = {}));
exports.DEFAULT_PLATFORM = Platform.whitelabel;
//# sourceMappingURL=platform.js.map